<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.ConfigureDisplayColumns')"
    width="600px"
    :close-on-click-modal="false"
    class="column-config-dialog"
  >
    <el-input
      v-model="keyword"
      style="width: 49%;margin-bottom: 5px;"
      :placeholder="$t('CargoMsg.Cargo_PleaseInputKeyWordsForQuery')"
      clearable
    >
      <i slot="suffix" class="el-icon-search" style="line-height: 25px;font-size: 12px;padding: 3px 1px 0 0;" />
    </el-input>
    <cargo-left-right-resize style="height: 500px">
      <template slot="left">
        <div class="section" style="height: 100%;">
          <div style="flex: 1;position: relative">
            <div style="position: absolute;width: 100%;height: 100%;">
              <el-table
                :data="leftFilterRows"
                border
                stripe
                row-key="serialNumber"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                style="height: 100%"
              >
                <el-table-column prop="name" :label="$t('Message.AllNames')" header-align="center" sortable>
                  <template slot-scope="{row}">
                    <span v-if="row.children">{{ row.name }}</span>
                    <el-checkbox v-else v-model="row.checked" @change="onCheckChange(row.id)">{{ row.name }}</el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </template>
      <template slot="right">
        <div class="section" style="height: 100%;">
          <div style="flex: 1;position: relative">
            <div style="position: absolute;width: 100%;height: 100%;">
              <el-table
                :data="rightRows"
                border
                stripe
                row-key="serialNumber"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                default-expand-all
                style="height: 100%"
              >
                <el-table-column prop="name" :label="$t('Message.SelectedColumns')" header-align="center" sortable>
                  <template slot-scope="{row}">
                    <div style="display: inline;">
                      {{ row.name }}
                      <i
                        class="el-icon-close"
                        style="float: right;line-height: 23px;cursor: pointer;"
                        @click="onRightClose(row.id)"
                      />
                      <i
                        class="el-icon-bottom"
                        style="float: right;line-height: 23px;cursor: pointer;"
                        @click="onRightBottom(row.id)"
                      />
                      <i class="el-icon-top" style="float: right;line-height: 23px;cursor: pointer;" @click="onRightTop(row.id)" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { AutoIncrementNum } from '@/utils/commonUtil'

export default {
  name: 'ColumnConfigDialog',
  components: { CargoLeftRightResize },
  props: {
    visible: { type: Boolean, required: true },
    descriptorRegistry: { type: Object, default: null },
    reportId: { type: String, default: '' },
    factTableId: { type: String, default: '' },
    factTableColumnId: { type: String, default: '' },
    factTableNumber: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      needInit: true,
      keyword: '',
      leftRows: [],
      rightRows: [],
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    cacheKey() {
      return this.reportId + this.factTableColumnId + '_' + this.factTableNumber
    },
    leftFilterRows() {
      if (this.keyword) {
        const result = []
        for (const row of this.leftRows) {
          if (row.name.includes(this.keyword)) {
            result.push(row)
          } else if (row.children && row.children.length > 0) {
            const newChildren = []
            for (const child of row.children) {
              if (child.name.includes(this.keyword)) {
                newChildren.push(child)
              }
            }
            if (newChildren.length > 0) {
              result.push({ ...row, children: newChildren })
            }
          }
        }
        return result
      } else {
        return this.leftRows
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.needInit) {
            this.initData()
          }
          const ids = LocalStorageUtilsNew.getConfiguration(this.cacheKey)
          if (ids) {
            for (const id of ids) {
              this.onCheckChange(id, true)
            }
          }
        }
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        for (const row of this.leftRows) {
          row.checked = false
          if (row.children) {
            for (const child of row.children) {
              child.checked = false
            }
          }
        }
        this.keyword = ''
        this.rightRows = []
      }
    },
    descriptorRegistry(newVal) {
      this.needInit = true
    },
    factTableId() {
      this.needInit = true
    }
  },
  methods: {
    initData() {
      if (!this.descriptorRegistry || !this.factTableId) {
        this.leftRows = []
        return
      }
      const rows = []
      const factTables = this.descriptorRegistry.factTables
      const dimensionTables = this.descriptorRegistry.dimensionTables
      for (const factTable of factTables) {
        if (factTable.id === this.factTableId) {
          const facts = factTable.facts
          const details = factTable.details
          const dimensions = factTable.dimensions
          for (const fact of facts) {
            rows.push({
              serialNumber: this.autoIncrementNum.getNextNum(),
              id: fact.id,
              name: fact.name,
              dataType: fact.dataType,
              dataTypeString: fact.dataTypeString,
              checked: false
            })
          }
          for (const detail of details) {
            rows.push({
              serialNumber: this.autoIncrementNum.getNextNum(),
              id: detail.id,
              name: detail.name,
              dataType: detail.dataType,
              dataTypeString: detail.dataTypeString,
              checked: false
            })
          }
          for (const dimension of dimensions) {
            rows.push(this.convertData(dimensionTables, dimension))
          }
        }
      }
      this.leftRows = rows
    },
    // 转换为表格所需数据
    convertData(dimensionTables, descriptor, parent) {
      const data = {
        serialNumber: this.autoIncrementNum.getNextNum(),
        id: descriptor.id,
        name: descriptor.name,
        dataType: descriptor.dataType,
        dataTypeString: descriptor.dataTypeString,
        checked: false
      }
      const children = this.getDimensionById(descriptor, dimensionTables, data)
      if (children.length > 0) {
        data.children = children
      }
      return data
    },
    getDimensionById(descriptor, dimensionTables, parent) {
      const list = []
      for (const dimensionTable of dimensionTables) {
        if (dimensionTable.id === descriptor.dataTypeString) {
          const columns = dimensionTable.columns
          for (const column of columns) {
            list.push({
              serialNumber: this.autoIncrementNum.getNextNum(),
              id: descriptor.id + ',' + column.id,
              name: column.name,
              dataType: column.dataType,
              dataTypeString: column.dataTypeString,
              checked: false
            })
          }
        }
      }
      return list
    },
    onCheckChange(id, checked) {
      const ids = id.split(',')
      let row = this.leftRows.find(p => p.id === ids[0])
      if (ids.length > 1 && row.children) {
        const index = this.rightRows.findIndex(p => p.id === row.id)
        const child = row.children.find(p => p.id === id)
        if (typeof checked !== 'undefined') {
          child.checked = checked
        }
        if (index >= 0) {
          row = this.rightRows[index]
          if (child.checked) {
            row.children.push(child)
          } else {
            const childIndex = row.children.findIndex(p => p.id === id)
            row.children.splice(childIndex, 1)
            if (row.children.length === 0) {
              this.rightRows.splice(index, 1)
            }
          }
        } else if (child.checked) {
          row = { ...row, children: [child] }
          this.rightRows.push(row)
        }
      } else {
        if (typeof checked !== 'undefined') {
          row.checked = checked
        }
        if (row.checked) {
          this.rightRows.push(row)
        } else {
          const index = this.rightRows.findIndex(p => p.id === row.id)
          this.rightRows.splice(index, 1)
        }
      }
    },
    onRightClose(id) {
      this.onCheckChange(id, false)
    },
    onRightBottom(id) {
      const ids = id.split(',')
      const index = this.rightRows.findIndex(p => p.id === ids[0])
      const row = this.rightRows[index]
      if (ids.length > 1) {
        const childIndex = row.children.findIndex(p => p.id === id)
        const child = row.children[childIndex]
        if (childIndex < row.children.length - 1) {
          const t = row.children[childIndex + 1]
          row.children[childIndex + 1] = child
          row.children[childIndex] = t
        }
      } else {
        if (index < this.rightRows.length - 1) {
          const t = this.rightRows[index + 1]
          this.rightRows[index + 1] = row
          this.rightRows[index] = t
        }
      }
      this.rightRows = [...this.rightRows]
    },
    onRightTop(id) {
      const ids = id.split(',')
      const index = this.rightRows.findIndex(p => p.id === ids[0])
      const row = this.rightRows[index]
      if (ids.length > 1) {
        const childIndex = row.children.findIndex(p => p.id === id)
        const child = row.children[childIndex]
        if (childIndex > 0) {
          const t = row.children[childIndex - 1]
          row.children[childIndex - 1] = child
          row.children[childIndex] = t
        }
      } else {
        if (index > 0) {
          const t = this.rightRows[index - 1]
          this.rightRows[index - 1] = row
          this.rightRows[index] = t
        }
      }
      this.rightRows = [...this.rightRows]
    },
    okHandler() {
      const ids = []
      for (const row of this.rightRows) {
        if (row.children) {
          for (const child of row.children) {
            ids.push(child.id)
          }
        } else {
          ids.push(row.id)
        }
      }
      LocalStorageUtilsNew.setConfiguration(this.cacheKey, ids)
      this.innerVisible = false
      this.$emit('enter')
    }
  }
}
</script>

<style lang="scss" scoped>
.column-config-dialog::v-deep .el-table {
  display: flex;
  flex-direction: column;
  .el-table__header-wrapper {
    flex-shrink: 0;
  }
  .el-table__body-wrapper {
    flex-grow: 1;
    overflow-y: auto;
  }
}
</style>
